module.exports = __webpack_public_path__ + "img/preszii-min.8595fd40.png";